import { render, staticRenderFns } from "./liveSelectionDetail.vue?vue&type=template&id=2f3f0ebf&scoped=true"
import script from "./liveSelectionDetail.vue?vue&type=script&lang=js"
export * from "./liveSelectionDetail.vue?vue&type=script&lang=js"
import style0 from "./liveSelectionDetail.vue?vue&type=style&index=0&id=2f3f0ebf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f0ebf",
  null
  
)

export default component.exports